import axios from 'axios'
import { QueryClient, useQuery, useQueryClient } from '@tanstack/react-query'
import { Slide } from '../types'
import { serializeQueryParams } from './utils'

export async function getSlides(
  params: Record<string, any> = {},
  signal?: AbortSignal
) {
  return (
    await axios.get(`/api/slides/`, {
      params: serializeQueryParams(params),
      signal,
    })
  ).data as Slide[]
}

export function prefetchSlides(
  client: QueryClient,
  params: Record<string, any> = {}
) {
  return client.prefetchQuery(['slides', params], ({ signal }) =>
    getSlides(params, signal)
  )
}

export function usePrefetchSlides(params: Record<string, any> = {}) {
  const queryClient = useQueryClient()
  prefetchSlides(queryClient, params)
}

export function useSlides(params: Record<string, any> = {}) {
  return useQuery(
    ['slides', params],
    ({ signal }) => getSlides(params, signal),
    {
      keepPreviousData: true,
    }
  ).data!
}
